var _desc, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "download_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    transform: "translate(49 -97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "download_icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path0_fill",
    transform: "translate(-41 120.2)",
    fill: "#868686"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path1_fill",
    transform: "translate(-49 97)",
    fill: "#868686"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path2_fill",
    transform: "translate(-40.6 106.6)",
    fill: "#868686"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    d: "M 0.4 0.8L 3.6 0.8C 3.84 0.8 4 0.64 4 0.4C 4 0.16 3.84 0 3.6 0L 0.4 0C 0.16 0 0 0.16 0 0.4C 0 0.64 0.16 0.8 0.4 0.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1_fill",
    d: "M 2.8 15.56L 2.8 23.2C 2.8 24.52 3.88 25.6 5.2 25.6L 14.8 25.6C 16.12 25.6 17.2 24.52 17.2 23.2L 17.2 15.56C 18.76 15.36 20 14 20 12.4C 20 10.8 18.76 9.44 17.2 9.24L 17.2 2.4C 17.2 1.08 16.12 0 14.8 0L 5.2 0C 3.88 0 2.8 1.08 2.8 2.4L 2.8 9.24C 1.24 9.44 0 10.8 0 12.4C 0 14 1.24 15.36 2.8 15.56ZM 16.4 23.2C 16.4 24.08 15.68 24.8 14.8 24.8L 5.2 24.8C 4.32 24.8 3.6 24.08 3.6 23.2L 3.6 22.4L 16.4 22.4L 16.4 23.2ZM 16.4 21.6L 3.6 21.6L 3.6 15.6L 16.4 15.6L 16.4 21.6ZM 3.6 2.4C 3.6 1.52 4.32 0.8 5.2 0.8L 14.8 0.8C 15.68 0.8 16.4 1.52 16.4 2.4L 16.4 3.2L 3.6 3.2L 3.6 2.4ZM 3.6 4L 16.4 4L 16.4 9.24C 16.24 9.24 16.08 9.28 15.96 9.32C 15.6 7.2 13.8 5.6 11.6 5.6C 10.16 5.6 8.84 6.32 8 7.48C 7.64 7.32 7.2 7.2 6.8 7.2C 5.48 7.2 4.4 8.08 4.08 9.32C 3.92 9.28 3.76 9.24 3.6 9.24L 3.6 4ZM 3.2 10C 3.56 10 3.92 10.08 4.24 10.24C 4.36 10.28 4.52 10.28 4.6 10.24C 4.72 10.16 4.8 10.04 4.8 9.92C 4.84 8.84 5.72 8.04 6.8 8.04C 7.2 8.04 7.6 8.16 7.92 8.36C 8 8.44 8.12 8.44 8.24 8.4C 8.36 8.36 8.44 8.32 8.48 8.2C 9.12 7.08 10.32 6.4 11.6 6.4C 13.56 6.4 15.12 7.92 15.2 9.88C 15.2 10 15.28 10.12 15.4 10.2C 15.52 10.28 15.64 10.28 15.8 10.2C 16.12 10.04 16.48 9.96001 16.84 9.96001C 18.16 9.96001 19.24 11.04 19.24 12.36C 19.24 13.68 18.16 14.76 16.84 14.76L 3.2 14.76C 1.88 14.76 0.8 13.68 0.8 12.36C 0.8 11.04 1.88 10 3.2 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2_fill",
    d: "M 1.32 3.88C 1.36 3.92 1.4 3.96 1.44 3.96C 1.48 4 1.56 4 1.6 4C 1.64 4 1.72 4 1.76 3.96C 1.8 3.92 1.84 3.92 1.88 3.88L 3.08 2.68C 3.24 2.52 3.24 2.28 3.08 2.12C 2.92 1.96 2.68 1.96 2.52 2.12L 2 2.64L 2 0.4C 2 0.16 1.84 0 1.6 0C 1.36 0 1.2 0.16 1.2 0.4L 1.2 2.64L 0.680001 2.12C 0.520001 1.96 0.28 1.96 0.12 2.12C -0.0400003 2.28 -0.0400003 2.52 0.12 2.68L 1.32 3.88Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.7ba45d10803b8e9b5f8076290a15c692.svg";
export { ForwardRef as ReactComponent };